module.exports = __webpack_public_path__ + "img/section_3@2x.81a2af3f.png";